/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GDPRConsentResponse } from './GDPRConsentResponse';
import {
    GDPRConsentResponseFromJSON,
    GDPRConsentResponseFromJSONTyped,
    GDPRConsentResponseToJSON,
    GDPRConsentResponseToJSONTyped,
} from './GDPRConsentResponse';
import type { APIResponseError } from './APIResponseError';
import {
    APIResponseErrorFromJSON,
    APIResponseErrorFromJSONTyped,
    APIResponseErrorToJSON,
    APIResponseErrorToJSONTyped,
} from './APIResponseError';
import type { APIMeta } from './APIMeta';
import {
    APIMetaFromJSON,
    APIMetaFromJSONTyped,
    APIMetaToJSON,
    APIMetaToJSONTyped,
} from './APIMeta';

/**
 * 
 * @export
 * @interface GetConsentGdpr200Response
 */
export interface GetConsentGdpr200Response {
    /**
     * 
     * @type {APIMeta}
     * @memberof GetConsentGdpr200Response
     */
    meta?: APIMeta;
    /**
     * 
     * @type {Array<APIResponseError>}
     * @memberof GetConsentGdpr200Response
     */
    errors?: Array<APIResponseError>;
    /**
     * 
     * @type {GDPRConsentResponse}
     * @memberof GetConsentGdpr200Response
     */
    result?: GDPRConsentResponse;
}

/**
 * Check if a given object implements the GetConsentGdpr200Response interface.
 */
export function instanceOfGetConsentGdpr200Response(value: object): value is GetConsentGdpr200Response {
    return true;
}

export function GetConsentGdpr200ResponseFromJSON(json: any): GetConsentGdpr200Response {
    return GetConsentGdpr200ResponseFromJSONTyped(json, false);
}

export function GetConsentGdpr200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetConsentGdpr200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'meta': json['meta'] == null ? undefined : APIMetaFromJSON(json['meta']),
        'errors': json['errors'] == null ? undefined : ((json['errors'] as Array<any>).map(APIResponseErrorFromJSON)),
        'result': json['result'] == null ? undefined : GDPRConsentResponseFromJSON(json['result']),
    };
}

export function GetConsentGdpr200ResponseToJSON(json: any): GetConsentGdpr200Response {
    return GetConsentGdpr200ResponseToJSONTyped(json, false);
}

export function GetConsentGdpr200ResponseToJSONTyped(value?: GetConsentGdpr200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'meta': APIMetaToJSON(value['meta']),
        'errors': value['errors'] == null ? undefined : ((value['errors'] as Array<any>).map(APIResponseErrorToJSON)),
        'result': GDPRConsentResponseToJSON(value['result']),
    };
}

